import React, { useState } from 'react';
import {
  Grid,
  Button,
  Dialog,
  DialogContent,
  useTheme,
  useMediaQuery
} from "@material-ui/core";
import DynamicInput from '../InputComponents/DynamicInput';
import { States } from '../../helpers/state';
import { formatPhoneNumber } from '../../helpers/formatedNumber';
import services from '../../Services';
import { useEffect } from 'react';

const { hr } = services;


const EditEmergencyContact = ({ EmergencyEditModal }) => {

  let { employeeDetails, emergencyContact, open, close, mainFlag, setMainFlag } = EmergencyEditModal;

  const [updateEmergencyContact, setUpdateEmergencyContact] = useState()

  useEffect(() => {
    setUpdateEmergencyContact({
      name: emergencyContact?.name,
      relationship: emergencyContact?.relationship,
      phoneNumber: emergencyContact?.phoneNumber,
      address: emergencyContact?.address,
      city: emergencyContact?.city,
      state: emergencyContact?.state,
      zip: emergencyContact?.zip,
      BckName: emergencyContact?.BckName,
      BckRelationship: emergencyContact?.BckRelationship,
      BckPhone: emergencyContact?.BckPhone,
      abbrivation: States?.find(item => item?.abbreviation === emergencyContact?.state?.toUpperCase())
    })
  }, [])


   

  const theme = useTheme();

  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const filterCurrentPrimaryStatus = (key) => {
    let obj = States.filter(value => value.abbreviation == key)
    return obj[0]
  }


  const onChangeEditPhoneNumberOnEmergency = (value) => {
    setUpdateEmergencyContact({ ...updateEmergencyContact, BckPhone: value })
    let formatted = formatPhoneNumber(value)
    value = formatted
  }


  const onChangeUpdatePrimaryNumberFormated = (value) => {
    setUpdateEmergencyContact({ ...updateEmergencyContact, phoneNumber: value })
    let formatted = formatPhoneNumber(value)
    value = formatted
  }



  let fields = [
    { type: 1, name: "Primary Contact Name", initial: updateEmergencyContact?.name, isRequired: true, onChange: (value) => setUpdateEmergencyContact({ ...updateEmergencyContact, name: value }) },
    { type: 1, name: "Primary Relationship", initial: updateEmergencyContact?.relationship, isRequired: true, onChange: (value) => setUpdateEmergencyContact({ ...updateEmergencyContact, relationship: value }) },
    { type: 1, name: "Primary Phone", initial: formatPhoneNumber(updateEmergencyContact?.phoneNumber), isRequired: true, onChange: (value) => onChangeUpdatePrimaryNumberFormated(value) },
    { type: 1, name: "Primary Address", initial: updateEmergencyContact?.address, isRequired: false, onChange: (value) => setUpdateEmergencyContact({ ...updateEmergencyContact, address: value }) },
    { type: 1, name: "Primary City", initial: updateEmergencyContact?.city, isRequired: false, onChange: (value) => setUpdateEmergencyContact({ ...updateEmergencyContact, city: value }) },
    {
      type: 3, key: 'title', options: States, name: "Primary State", initial: filterCurrentPrimaryStatus(updateEmergencyContact?.state),
      onChange: (newValue) => setUpdateEmergencyContact({
        ...updateEmergencyContact, state: newValue?.abbreviation,
      }),
      isRequired: false
    },
    { type: 1, name: "Primary Zip", initial: updateEmergencyContact?.zip?.replace(/\D/g, ""), isRequired: false, onChange: (value) => setUpdateEmergencyContact({ ...updateEmergencyContact, zip: value }), maxlength: 5 },
    { type: 1, name: "Backup Name", initial: updateEmergencyContact?.BckName, isRequired: false, onChange: (value) => setUpdateEmergencyContact({ ...updateEmergencyContact, BckName: value }) },
    { type: 1, name: "Backup Relation", initial: updateEmergencyContact?.BckRelationship, isRequired: false, onChange: (value) => setUpdateEmergencyContact({ ...updateEmergencyContact, BckRelationship: value }) },
    { type: 1, name: "Backup Contact", initial: formatPhoneNumber(updateEmergencyContact?.BckPhone), isRequired: false, onChange: (value) => onChangeEditPhoneNumberOnEmergency(value) },

  ]


  function onUpdateEmergencyContact(e) {

    e.preventDefault();

    let data = {
      name: updateEmergencyContact?.name,
      relationship: updateEmergencyContact?.relationship,
      phoneNumber: updateEmergencyContact?.phoneNumber,
      BckName: updateEmergencyContact?.BckName,
      BckRelationship: updateEmergencyContact?.BckRelationship,
      BckPhone: updateEmergencyContact?.BckPhone,
      city: updateEmergencyContact?.city,
      state: updateEmergencyContact?.state,
      zip: updateEmergencyContact?.zip,
      address: updateEmergencyContact?.address,
      id: employeeDetails?.id

    }

    try {
      hr.updateEmergencyContactApi(data).then(() => {
        setMainFlag(!mainFlag)
      }).catch((err) => {   });

      close(false);

    }
    catch (exc) {
      close(false);
    }


  }


  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      onClose={() => close(false)}
      className="BroadcastMessageModal LiqTables"
      aria-labelledby="responsive-dialog-title"
    >
      <Button autoFocus onClick={() => close(false)} className="ModalClose">
      </Button>
      <form onSubmit={onUpdateEmergencyContact}>
        <DialogContent>
          <DynamicInput fields={fields} />
          <Grid xs={12} container justify="center" className="mt30">
            <Button type="submit" className="LinkButton">Save</Button>
          </Grid>
        </DialogContent>
      </form>
    </Dialog >
  )
}

export default EditEmergencyContact